import languageSwitcher from './language-switcher';
export default () => {
  languageSwitcher();
};